// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LTFCqbBFrUWj1HrUeaNL {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.QRzR4_W5BGFUsdAD_HFx {
  flex: auto;
  overflow: hidden;
}
.pNXgANrUTUA9iRydHYRJ {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  padding: 10px 5px;
  cursor: pointer;
}
.eR3N5gOnZE4DvqrLM4ks {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  padding: 10px 5px;
  cursor: pointer;
  right: -34px;
  top: calc(50% - 40px);
}
.jXIScGbd4RjsPWlp7h6I {
  border-right: 2px solid #ddd;
}
.IcjYbty6VE7H9GLUwQeu {
  border-left: 1px solid #ddd;
  height: 100%;
  overflow: hidden;
}
.CiOu3EWDbViAPKxcR5Px {
  height: 100%;
  width: 38px;
  text-align: center;
  padding: 10px 0;
  border-left: 2px solid #ddd;
}
.GjEIc9G62XnZzB8qfa0V {
  height: 40px;
  border-top: 1px solid #eee;
  justify-content: space-between;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AAAF;AAGA;EACE,UAAA;EACA,gBAAA;AADF;AAIA;EACE,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;AAFF;AAKA;EAPE,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EAKA,YAAA;EACA,qBAAA;AACF;AAEA;EACE,4BAAA;AAAF;AAGA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;AADF;AAIA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AAFF;AAKA;EACE,YAAA;EACA,0BAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AAHF","sourcesContent":["\n.orbitEditor {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.editorBody {\n  flex: auto;\n  overflow: hidden;\n}\n\n.panelTrigger {\n  position: absolute;\n  background-color: #fff;\n  z-index: 1;\n  padding: 10px 5px;\n  cursor: pointer;\n}\n\n.leftTrigger {\n  .panelTrigger;\n  right: -34px;\n  top: calc(50% - 40px);\n}\n\n.leftPanel {\n  border-right: 2px solid #ddd;\n}\n\n.rightPanel {\n  border-left: 1px solid #ddd;\n  height: 100%;\n  overflow: hidden;\n}\n\n.iconActions {\n  height: 100%;\n  width: 38px;\n  text-align: center;\n  padding: 10px 0;\n  border-left: 2px solid #ddd;\n}\n\n.footer {\n  height: 40px;\n  border-top: 1px solid #eee;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orbitEditor": `LTFCqbBFrUWj1HrUeaNL`,
	"editorBody": `QRzR4_W5BGFUsdAD_HFx`,
	"panelTrigger": `pNXgANrUTUA9iRydHYRJ`,
	"leftTrigger": `eR3N5gOnZE4DvqrLM4ks`,
	"leftPanel": `jXIScGbd4RjsPWlp7h6I`,
	"rightPanel": `IcjYbty6VE7H9GLUwQeu`,
	"iconActions": `CiOu3EWDbViAPKxcR5Px`,
	"footer": `GjEIc9G62XnZzB8qfa0V`
};
export default ___CSS_LOADER_EXPORT___;
